class MapLocationListController {
  constructor($timeout,LocationService, FiltersService, StateStoreService ) {
    this.name = 'mapLocationList';
    this.$timeout = $timeout;
    this.LocationService = LocationService;
    this.FiltersService = FiltersService;
    this.StateStoreService = StateStoreService;
  }

  $onInit() {
    var self = this;
    self.filtered = angular.copy(self.locations);

    self.selectedFilter = self.StateStoreService.get('selectedFilter');
    if(self.selectedFilter){
      self.filterByFilter();
    }
    self.selectedGroup = self.StateStoreService.get('selectedGroup');
    if(self.selectedGroup){
      self.filterByGroup();
    }
    // this.LocationService.getAll().then(
    //     (locations)=> {
    //       self.locations = locations;
    //       self.filtered = angular.copy(locations);
    //
    //       self.selectedFilter = self.StateStoreService.get('selectedFilter');
    //       if(self.selectedFilter){
    //         self.filterByFilter();
    //       }
    //       self.selectedGroup = self.StateStoreService.get('selectedGroup');
    //       if(self.selectedGroup){
    //         self.filterByGroup();
    //       }
    //     });

  }
  
  filterByFilter() {
    var self = this;
    self.$timeout(function(){

      self.StateStoreService.set('selectedFilter', self.selectedFilter);

      if(self.selectedFilter === -1){
        self.filtered = self.locations;
      }
      else{
        self.filtered = [];
        angular.forEach(self.locations, function(location){
          if(location.filter){
            if(location.filter.id === self.selectedFilter){
              self.filtered.push(location);
            }
          }

        });
      }

    }, 100);
  }
  
  filterByGroup() {
    var self = this;
    self.$timeout(function(){

      self.StateStoreService.set('selectedGroup', self.selectedGroup);

      if(self.selectedGroup === -1){
        self.filtered = self.locations;
      }
      else{
        self.filtered = [];
        angular.forEach(self.locations, function(location){
          if(self.selectedGroup === 1){
            // All year
            if(!location.isMcc){
              self.filtered.push(location);
            }
          }
          if(self.selectedGroup === 2){
            // MCC
            if(location.isMcc){
              self.filtered.push(location);
            }
          }

        });
      }

    }, 100);

  }
}
MapLocationListController.$inject = ['$timeout','LocationService', 'FiltersService', 'StateStoreService' ];
export default MapLocationListController;
